/**
 * DEV-1216, DEV-1818. Переводы блока «Витрина сайта» на вкладке юнитов
 * (эпик DEV-1075).
 *
 * Отдельным модулем, как propertyForm/propertyUnits/driveImport: правки витрины не конфликтуют
 * с общим ru.ts, который правят все подряд.
 *
 * Вьетнамская терминология согласована со вкладкой юнитов (propertyUnits): юнит —
 * «căn hộ», сводка типов на сайте — «bảng loại căn».
 */

const ruShowcase = {
  title: 'Витрина сайта',
  badge: {
    units: 'Из юнитов',
    manual: 'Вручную',
  },
  hint: {
    manual: 'Строки заводятся вручную. Появится первый юнит — витрина начнёт считаться из юнитов',
    units: 'Считается из видимых юнитов, обновляется при каждом изменении',
  },
  addObject: 'Добавить объект',
  form: {
    addTitle: 'Новая строка витрины',
    editTitle: 'Строка витрины',
    area: 'Площадь от, м²',
    areaRequired: 'Укажите площадь больше нуля',
    price: 'Цена от',
    priceHint: 'Пусто или ноль — на сайте будет «Цена по запросу»',
    currency: 'Валюта',
    roomsUnset: 'Не указана',
    visibility: 'Показывать на сайте',
    saved: 'Строка витрины сохранена',
    deleted: 'Строка витрины удалена',
    saveError: 'Не удалось сохранить строку витрины',
    confirmDelete: 'Удалить строку витрины? На сайте она исчезнет.',
  },
  replaceWarning: {
    title: 'Витрина будет пересчитана из юнитов',
    text: 'Сейчас на сайте {current} строк, заведённых вручную. После применения останется {preview} — они считаются из юнитов. Вернуть прежние строки можно будет только заведя их заново.',
    firstUnit:
      'У проекта {count} строк витрины, заведённых вручную. Первый же юнит переведёт витрину на расчёт из юнитов, и эти строки будут замещены. Продолжить?',
    columnCurrent: 'Сейчас на сайте',
    columnPreview: 'Станет после применения',
    confirm: 'Применить',
    cancel: 'Отмена',
    loadError: 'Не удалось посчитать, как изменится витрина',
  },
  noObjectType: 'Юнитов без типа: {count} — на витрину они не попадут',
  table: {
    type: 'Тип',
    rooms: 'Комнатность',
    area: 'Площадь от, м²',
    available: 'Доступно',
    priceFrom: 'Цена от (USD)',
  },
  priceOnRequest: 'Цена по запросу',
  empty: {
    manual: 'Витрина не заполнена',
    manualHint: 'Объекты заводятся в админке',
    units: 'Строк нет — появятся видимые юниты, появятся и строки',
  },
}

const enShowcase = {
  title: 'Website showcase',
  badge: {
    units: 'From units',
    manual: 'Manual',
  },
  hint: {
    manual:
      'Rows are created by hand. Once the project gets its first unit, the showcase is computed from units',
    units: 'Computed from visible units, refreshed on every change',
  },
  addObject: 'Add listing',
  form: {
    addTitle: 'New showcase row',
    editTitle: 'Showcase row',
    area: 'Area from, m²',
    areaRequired: 'Enter an area greater than zero',
    price: 'Price from',
    priceHint: 'Empty or zero shows «Price on request» on the site',
    currency: 'Currency',
    roomsUnset: 'Not set',
    visibility: 'Show on the site',
    saved: 'Showcase row saved',
    deleted: 'Showcase row deleted',
    saveError: 'Could not save the showcase row',
    confirmDelete: 'Delete this showcase row? It disappears from the site.',
  },
  replaceWarning: {
    title: 'The showcase will be recomputed from units',
    text: 'The site currently shows {current} manually created rows. After applying there will be {preview}, computed from units. Bringing the old rows back means creating them again.',
    firstUnit:
      'This project has {count} manually created showcase rows. The very first unit switches the showcase to units and replaces them. Continue?',
    columnCurrent: 'On the site now',
    columnPreview: 'After applying',
    confirm: 'Apply',
    cancel: 'Cancel',
    loadError: 'Could not compute how the showcase would change',
  },
  noObjectType: 'Units without a type: {count} — they will not reach the showcase',
  table: {
    type: 'Type',
    rooms: 'Rooms',
    area: 'Area from, m²',
    available: 'Available',
    priceFrom: 'Price from (USD)',
  },
  priceOnRequest: 'Price on request',
  empty: {
    manual: 'Showcase is empty',
    manualHint: 'Rows are created in the admin app',
    units: 'No rows yet — they appear once there are visible units',
  },
}

const vnShowcase = {
  title: 'Bảng loại căn trên website',
  badge: {
    units: 'Từ căn hộ',
    manual: 'Thủ công',
  },
  hint: {
    manual: 'Các dòng được nhập thủ công. Khi có căn hộ đầu tiên, bảng sẽ tự tính từ căn hộ',
    units: 'Tính từ căn hộ hiển thị, cập nhật sau mỗi thay đổi',
  },
  addObject: 'Thêm dòng',
  form: {
    addTitle: 'Dòng bảng loại căn mới',
    editTitle: 'Dòng bảng loại căn',
    area: 'Diện tích từ, m²',
    areaRequired: 'Nhập diện tích lớn hơn 0',
    price: 'Giá từ',
    priceHint: 'Để trống hoặc 0 sẽ hiển thị «Giá theo yêu cầu»',
    currency: 'Tiền tệ',
    roomsUnset: 'Chưa xác định',
    visibility: 'Hiển thị trên website',
    saved: 'Đã lưu dòng bảng loại căn',
    deleted: 'Đã xoá dòng bảng loại căn',
    saveError: 'Không thể lưu dòng bảng loại căn',
    confirmDelete: 'Xoá dòng này? Nó sẽ biến mất khỏi website.',
  },
  replaceWarning: {
    title: 'Bảng loại căn sẽ được tính lại từ căn hộ',
    text: 'Website đang hiển thị {current} dòng nhập thủ công. Sau khi áp dụng sẽ còn {preview} dòng tính từ căn hộ. Muốn quay lại thì phải nhập tay từ đầu.',
    firstUnit:
      'Dự án có {count} dòng bảng loại căn nhập thủ công. Căn hộ đầu tiên sẽ chuyển bảng sang chế độ tính tự động và thay thế các dòng này. Tiếp tục?',
    columnCurrent: 'Hiện tại trên website',
    columnPreview: 'Sau khi áp dụng',
    confirm: 'Áp dụng',
    cancel: 'Huỷ',
    loadError: 'Không thể tính trước thay đổi của bảng',
  },
  noObjectType: 'Căn hộ chưa có loại: {count} — sẽ không lên bảng loại căn',
  table: {
    type: 'Loại',
    rooms: 'Số phòng',
    area: 'Diện tích từ, m²',
    available: 'Còn trống',
    priceFrom: 'Giá từ (USD)',
  },
  priceOnRequest: 'Giá theo yêu cầu',
  empty: {
    manual: 'Bảng trống',
    manualHint: 'Dòng được tạo trong ứng dụng quản trị',
    units: 'Chưa có dòng — sẽ xuất hiện khi có căn hộ hiển thị',
  },
}

export const propertyShowcaseMessages = {
  ru: { properties: { showcase: ruShowcase } },
  en: { properties: { showcase: enShowcase } },
  vn: { properties: { showcase: vnShowcase } },
}
